import React from 'react';
import { Alert, Text } from '@gjensidige/builders-components';
import { Coverage, HeaderSmallScreen } from '../../../interfaces/Types';
import { CoverageList } from '../../CoverageList/CoverageList';
interface Props {
  header?: HeaderSmallScreen;
  includedCoverages: Coverage[];
  excludedCoverages: Coverage[];
  disabledMessage?: string;
  isEnabled: boolean;
}

export type ComponentProps = Props;

export const InsuranceTileContentSmallScreen: React.FC<Props> = ({
  header,
  includedCoverages,
  excludedCoverages,
  isEnabled,
  disabledMessage
}: Props) => {
  return (
    <div className="small-screen-coverage-wrapper">
      {header?.priceLabel && header?.monthlyPrice && isEnabled ? (
        <>
          {includedCoverages?.length > 0 && (
            <CoverageList coverages={includedCoverages} includedCoverage />
          )}
          {excludedCoverages?.length > 0 && (
            <CoverageList coverages={excludedCoverages} />
          )}
        </>
      ) : !isEnabled && disabledMessage ? (
        <Alert 
          severity="informative"
          variant="outlined"
          className="mx-2 mb-3"
        >
          <Text size="body" dangerouslySetInnerHTML={{ __html: disabledMessage }}></Text>
        </Alert>
      ) : (
        <></>
      )}
    </div>
  );
};
